const SUCCESS_ALERT_TEXT = 'Enviado correctamente';
const GENERIC_ERROR_ALERT_TEXT = 'Ocurrió un error.';

function failedList(canal) {
  if (!canal || !Array.isArray(canal.failed)) {
    return [];
  }
  return canal.failed;
}

/** Maps a completed Envío body to the operator success or error alert. */
export function envioResultAlert(body) {
  const sms = body && body.sms;
  const email = body && body.email;
  const smsSent = Number(sms && sms.sent) || 0;
  const emailSent = Number(email && email.sent) || 0;
  const smsFailed = failedList(sms);
  const emailFailed = failedList(email);
  if (smsSent + emailSent === 0 && smsFailed.length + emailFailed.length > 0) {
    return {kind: 'error', text: GENERIC_ERROR_ALERT_TEXT};
  }
  if (smsFailed.length === 0 && emailFailed.length === 0) {
    return {kind: 'success', text: SUCCESS_ALERT_TEXT};
  }

  const entregas = smsFailed.length + emailFailed.length;
  const detalle = entregas === 1
    ? 'ha fallado 1 envío'
    : 'han fallado ' + entregas + ' envíos';
  return {kind: 'warning', text: 'Envío realizado, ' + detalle};
}
